import noUiSlider from 'nouislider';

class Filters {
    constructor() {
        this.form = document.querySelector('.filters__form');
        this.orderby = document.querySelector('#trier-par');
        this.filtersType = document.querySelector('body').classList.contains('page-template-tpl-wheels') ? 'wheel' : 'products';
        this.rangeBudget = null;
        this.rangeKm = null;

        this.initEvents();
    }

    initEvents() {
        if (this.orderby) {
            this.orderby.addEventListener('change', () => {
                const baseUrl = new URL(window.location.href);

                baseUrl.searchParams.set('tri', this.orderby.value);

                window.location.href = baseUrl.href;
            });
        }

        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                const constructor = document.querySelector('#filter__brand').value;
                const model = document.querySelector('#filter__model').value;
                const baseAction = document.querySelector('.filters__baseurl').value;
                let action = baseAction;

                let data = null;

                if (this.filtersType === 'products') {
                    if (constructor !== '') {
                        action = `${action}/${constructor}`;
                    }
                    if (constructor !== '' && model !== '') {
                        action = `${action}/${model}`;
                    }
                    data = {
                        vitesse: this.getCheckedBoxes('vitesse'),
                        energies: this.getCheckedBoxes('energies'),
                    };

                    if (this.rangeBudget) {
                        data.budget = this.rangeBudget.get().map(value => parseInt(value, 10)).join('-');
                    }

                    if (this.rangeKm) {
                        data.km = this.rangeKm.get().map(value => parseInt(value, 10)).join('-');
                    }
                } else {
                    data = {
                        constructeur: constructor,
                        modele: model,
                        pneu: this.getCheckedBoxes('pneu'),
                        jante: this.getCheckedBoxes('jante'),
                        taille: this.getCheckedBoxes('taille'),
                        reserve: this.getCheckedBoxes('reserve'),
                    };
                }
                const queryArgs = this.encodeDataToURL(data);
                console.log('action', action);

                window.location.href = `${action}?${queryArgs}`;
            });

            if (document.querySelector('.filters__budget')) {
                const budget = document.querySelector('.filters__budget');
                const budgetMin = document.querySelector('.filters__budget_container .range__min');
                const budgetMax = document.querySelector('.filters__budget_container .range__max');
                this.rangeBudget = noUiSlider.create(budget, { // eslint-disable-line
                    range: {
                        min: parseInt(budget.getAttribute('data-min'), 10),
                        max: parseInt(budget.getAttribute('data-max'), 10),
                    },
                    start: [
                        parseInt(budget.getAttribute('data-current-min'), 10),
                        parseInt(budget.getAttribute('data-current-max'), 10),
                    ],
                    step: 1000,
                    margin: 5000,
                    connect: true,
                });

                budget.noUiSlider.on('update', (values) => {
                    budgetMin.innerHTML = `${new Intl.NumberFormat().format(values[0])} €`;
                    budgetMax.innerHTML = `${new Intl.NumberFormat().format(values[1])} €`;
                });
            }

            if (document.querySelector('.filters__km')) {
                const km = document.querySelector('.filters__km');
                const kmMin = document.querySelector('.filters__km_container .range__min');
                const kmMax = document.querySelector('.filters__km_container .range__max');
                this.rangeKm = noUiSlider.create(km, { // eslint-disable-line
                    range: {
                        min: 0,
                        max: parseInt(km.getAttribute('data-max'), 10),
                    },
                    start: [
                        parseInt(km.getAttribute('data-current-min'), 10),
                        parseInt(km.getAttribute('data-current-max'), 10),
                    ],
                    step: 5000,
                    margin: 10000,
                    connect: true,
                });

                km.noUiSlider.on('update', (values) => {
                    kmMin.innerHTML = `${new Intl.NumberFormat().format(values[0])} km`;
                    kmMax.innerHTML = `${new Intl.NumberFormat().format(values[1])} km`;
                });
            }
        }
    }

    encodeDataToURL(data) { // eslint-disable-line
        return Object
            .keys(data)
            .filter(value => data[value] !== null)
            .map(value => `${value}=${encodeURIComponent(data[value])}`)
            .join('&');
    }

    getCheckedBoxes(chkboxName) { // eslint-disable-line
        const checkboxes = document.getElementsByName(chkboxName);
        const checkboxesChecked = [];
        // loop over them all
        for (let i = 0; i < checkboxes.length; i++) { // eslint-disable-line
            // And stick the checked ones onto an array...
            if (checkboxes[i].checked) {
                checkboxesChecked.push(checkboxes[i].value);
            }
        }
        // Return the array if it is non-empty, or null
        return checkboxesChecked.length > 0 ? checkboxesChecked.join('-') : null;
    }
}

export default Filters;
